type LicenseType = 'software' | 'servicedesk' | 'customerservice';

const appPermissionMapper = {
	software: 'hasSoftwareAccess' as const,
	servicedesk: 'hasServiceDeskAccess' as const,
	customerservice: 'hasCustomerServiceAccess' as const,
};

type Context = {
	appPermissions?: {
		hasSoftwareAccess?: boolean;
		hasServiceDeskAccess?: boolean;
		hasCustomerServiceAccess?: boolean;
	};
};

/**
 * Imperative License Check
 */
export const checkLicense = (tenantContext: Context, type: LicenseType): boolean => {
	const key = appPermissionMapper[type];
	return Boolean(tenantContext.appPermissions && tenantContext.appPermissions[key]);
};
